import { Tooltip, makeStyles } from '@material-ui/core'
import { ArrowForward, Close } from '@material-ui/icons'
import React, { useState, useReducer, useEffect } from 'react'
import {
  useMutation,
  useNotify,
  useRecordContext,
  useRefresh,
  useShowContext,
  useTranslate,
} from 'react-admin'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { ToggleType } from '../../../../core/devices/barriers/barrier-set-boolean-status-button'
import { BarrierSelectStateDialog } from '../BarrierDialogs'
import { BarrierDto } from '../../../../core/dto/device/barrier/barrier.dto'
import {
  barrierSetFreePassButtonInitialState,
  barrierSetFreePassButtonReducer,
} from '../../../../core/devices/barriers/barrier-set-free-pass-button.reducer'

const useStyles = makeStyles({
  iconContainer: {
    position: 'relative',
    width: 34,
  },
  icon: {
    position: 'absolute',
    left: 5,
    top: 5,
    fontSize: '24px !important',
  },
  crossIcon: {
    position: 'absolute',
    left: 0,
    top: 0,
    fontSize: 34,
    opacity: 0.8,
  },
})

export const BarrierSetFreePassCompactButton = ({ ...props }) => {
  const { disabled, FreePassForward } = props
  const notify = useNotify()
  const { loading } = useShowContext()
  const translate = useTranslate()
  const classes = useStyles()
  const hasAuthority = useHasAuthority()

  const [{ mutateQuery }, dispatch] = useReducer(
    barrierSetFreePassButtonReducer,
    barrierSetFreePassButtonInitialState,
  )
  const [dialogOpen, setDialogOpen] = useState(false)
  const [state, setState] = useState(false)
  const barrier = useRecordContext<BarrierDto>()
  const [mutate, { loading: mutationLoading }] = useMutation()
  const refresh = useRefresh()

  useEffect(() => {
    if (state) {
      dispatch({ type: ToggleType.OFF })
    } else {
      dispatch({ type: ToggleType.ON })
    }
  }, [state])

  const handleFreePass = async (
    recurringJobName?: string,
    cronExpression?: string,
    auditNote?: string,
  ) => {
    const query = mutateQuery?.(barrier, auditNote)
    await mutate(query, {
      returnPromise: true,
      onFailure: (err) => notify(err?.message, 'error'),
    })
    refresh()
  }

  return (
    <>
      <BarrierSelectStateDialog
        open={dialogOpen}
        confirm={handleFreePass}
        method="freePass"
        close={() => setDialogOpen(false)}
        state={state}
        setState={setState}
        OnIcon={<ArrowForward className={classes.icon} />}
        OffIcon={
          <>
            <ArrowForward className={classes.icon} />
            <Close fontSize="large" className={classes.crossIcon} />
          </>
        }
        withAuditNote
      />
      <Tooltip
        title={translate('resources.modules.fields.freePass')}
        onClick={
          !loading &&
          !mutationLoading &&
          !disabled &&
          hasAuthority(Authority.BARRIERS_SET_FREE_PASS_BUTTON)
            ? () => setDialogOpen(true)
            : undefined
        }
      >
        <div
          className={classes.iconContainer}
          style={{
            cursor:
              !loading &&
              !mutationLoading &&
              !disabled &&
              hasAuthority(Authority.BARRIERS_SET_FREE_PASS_BUTTON)
                ? 'pointer'
                : 'default',
          }}
        >
          <ArrowForward className={classes.icon} />
          {!FreePassForward ? (
            <Close fontSize="large" className={classes.crossIcon} />
          ) : undefined}
        </div>
      </Tooltip>
    </>
  )
}
